<template>
  <div class="form-container">

    <!-- Nova Questão: Água -->
    <div class="question-group">
      <label class="required">Água Mineral:</label>
      <div class="checkbox-group">
        <label v-for="(agua, index) in aguas" :key="index">
              <input 
              type="radio"
              name="agua" 
              v-model="cardapio.agua" 
              :value="agua" 
              :onchange="emitirCardapio"/> {{  agua }}
        </label>
      </div>
    </div>
    <div class="itens-selecionados">
      Água selecionada: {{ cardapio.agua }}
    </div>

    <!-- Nova Questão: Café -->
    <div class="question-group">
      <label class="required">Café Sem Açúcar:</label>
      <div class="checkbox-group">
        <label v-for="(cafe, index) in cafes" :key="index">
              <input 
              type="radio"
              name="cafe" 
              v-model="cardapio.cafe" 
              :value=" cafe" 
              :onchange="emitirCardapio"/> {{  cafe }}
        </label>
      </div>
      <div class="instrucoes">
        adoçante e açúcar a parte
      </div>
    </div>
    <div class="itens-selecionados">
      Café: {{ cardapio.cafe }}
    </div>

    <!-- Questão do Suco -->
     <br />
    <div class="question-group">
      <label class="required">Néctar de Frutas:</label>
      <div class="checkbox-group">
        <label v-for="(suco, index) in sucos" :key="index">
              <input 
              type="checkbox" 
              name="sucos"
              :disabled="cardapio.sucos.length >= 2 && !cardapio.sucos.includes(suco)" 
              v-model="cardapio.sucos" 
              :value="suco" 
              @change="handleSucosClick"/> {{ suco }}
        </label>
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Suco(s) selecionado(s): {{ cardapio.sucos.join(', ') }}
    </div>

    <!-- Nova Questão: Chá -->
    <div class="question-group">
      <label class="required">Chá Matte:</label>
      <div class="checkbox-group">
        <label v-for="(c, index) in cha" :key="index">
              <input 
              type="radio"
              name="cha" 
              v-model="cardapio.cha" 
              :value="c" 
              :onchange="emitirCardapio"/> {{  c }}
        </label>
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Chá selecionado: {{ cardapio.cha }}
    </div>

    <!-- Nova Questão: Salgado Assado -->
    <div class="question-group">
      <label class="required">Salgado Assado:</label>
      <div class="checkbox-group">
          <label v-for="(assado, index) in assados" :key="index">
              <input type="radio" name="assados" v-model="cardapio.assado" :value="assado" :onchange="emitirCardapio"/>
              {{ assado }} 
        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Assado selecionado: 
      <span v-if="cardapio.assado">
        {{ cardapio.assado }}
      </span>
    </div>

    <!-- Nova Questão: Sanduiche -->
    <div class="question-group">
      <label class="required">Sanduíche no Brioche</label>
      <div class="checkbox-group">
          <label v-for="(sanduiche, index) in sanduiches" :key="index">
              <input type="radio" name="sanduiches" v-model="cardapio.sanduiche" :value="sanduiche" :onchange="emitirCardapio"/>
              {{ sanduiche }}
        </label>           
      </div>
      <div class="instrucoes">
        (1 opção)
      </div>
    </div>
    <div class="itens-selecionados">
      Sanduíche selecionado: 
      <span>
        {{ cardapio.sanduiche }}
      </span>
    </div>

    <!-- Nova Questão: Bolos -->
    <div class="question-group">
      <label class="required">Bolo</label>
      <div class="checkbox-group">
          <label v-for="(bolo, index) in bolos" :key="index">
               <input 
              type="checkbox" 
              :disabled="cardapio.bolos.length >= 2 && !cardapio.bolos.includes(bolo)" 
              v-model="cardapio.bolos" 
              :value="bolo" 
              :onchange="emitirCardapio" /> {{ bolo }}

        </label>           
      </div>
      <div class="instrucoes">
        (2 opções)
      </div>
    </div>
    <div class="itens-selecionados">
      Bolo(s) selecionado(s): 
      <span v-if="cardapio.bolos.length > 0">
        {{ cardapio.bolos.join(', ') }}
      </span>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    tipoCardapio: {
      type: Number,
      default: null
    },
  },
  data() {
    return {

      doces:[
        'Carolina de Doce de Leite',
        'Carolina de Brigadeiro',
        'Mini Sonho',
        'Mini Churros'
      ],

      bolos: [
        'Chocolate',
        'Laranja',
        'Limão',
        'Fubá',
        'Mármore',
        'Formigueiro'
      ],

      assados: [
        'Mini Croissant',
        'Mini Folhado Queijo',
        'Mini Quiche de Queijo',
        'Mini Pão de Batata Recheado com Frango',
        'Mini Pão de Batata Recheado com Requeijão Cremoso',
      ],

      sanduiches: [
        'Presunto e Queijo',
        'Peito de Peru com Queijo Branco',
      ],

      cha: [
        'Quente com limão',
        'Quente sem limão',
        'Frio com limão',
        'Frio sem limão',
        'Não',
      ],

      aguas: [
        'Sim',
        'Não',
      ],

      cafes: [
        'Sim',
        'Não',
      ],

      sucos: [
        'Abacaxi',
        'Laranja',
        'Pêssego',
        'Goiaba',
        'Uva',
        'Manga',
        'Caju',
        'Maracujá',
      ],

      cardapio: {
        tipoCardapio: null,
        sucos: [],
        agua: '', 
        cafe: '',
        cha: '',
        assado: '',
        sanduiche: '',
        bolos: []
      },
    };
  },

  methods: {

    resetCardapio(){

      this.cardapio = {
        tipoCardapio: null,
        sucos: [],
        agua: '', 
        cafe: '',
        cha: '',
        assado: '',
        sanduiche: '',
        bolos: []
      }
    },

    emitirCardapio() {
      this.$emit('atualizar-cardapio', this.cardapio);
    }

  },

  created(){

  },

  mounted() {
    this.resetCardapio();
  },

  computed: {

  }
};
</script>
  
<style src="../css/buffet.css"></style>

